/* eslint-disable no-dupe-keys */
export default {
  parking_lock: {
    name: '车位地锁',
    control_parking_lock: '控制地锁',
    change_status: {
      success: '{0}成功'
    },
    // 属性（一般与对象内容匹配）
    prop: {
      serial_number: '地锁编号',
      ev_charging_station: '充电站',
      ev_charging_pile: '充电桩',
      ev_charging_gun: '充电枪',
      lock_status: '地锁状态',
      battery: '地锁电量',
      parking_status: '车位状态',
      alarm_statuses: '报警状态',
      alarm_status: '报警状态',
      status_updated_at: '状态更新时间',
      created_at: '创建时间',
      updated_at: '更新时间',
      description: '备注',
      is_bind: '已绑定到枪',
      lock_status_not_match: '锁与枪状态不匹配',
      service_provider: '运营商',
      ev_charging_gun_status: '桩状态',
      last_start_time: '最近充电时间'
    },
    status_options: [
      { label: '控制降锁', value: 'down' },
      { label: '控制升锁', value: 'up' },
      { label: '地锁停用', value: 'stop' },
      { label: '地锁启用', value: 'start' },
      { label: '状态查询', value: 'check' }
    ],
    commands: {
      up: '升锁',
      down: '降锁',
      start: '启用',
      stop: '停用'
    },
    // Enum的属性
    lock_statuses: {
      down: '已降锁',
      up: '已升锁',
      reverse_down: '反向降锁',
      middle_of_down: '锁止与正向解锁之间',
      middle_of_reverse_down: '锁止与反向解锁之间 ',
      unknown: '未知'
    },
    parking_statuses: {
      vacancy: '空缺',
      occupation: '占用',
      unknown: '未知'
    },
    alarm_statuses: {
      normal: '无报警',
      stop: '停用',
      offline: '离网',
      ow_battery: '低电量',
      ultrasonic_fault: '超声波故障',
      battery_ultrasonic_fault: '低电量+超声波故障',
      up_blocked: '升锁遇阻',
      down_blocked: '降锁遇阻',
      locking_arm_move: '锁臂异动',
      weak_signal: '信号弱'
    },
    lock_status_not_matches: {
      true: '是',
      false: '否'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询电站/地锁编号/备注',
      input_description: '可选',
      input_serial_number: '留空则表示没地锁'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    // 按钮
    btn: {
      bulk_setting: '绑定地锁',
      bulk_operation: '一键启/停',
      start_all: '全部启动',
      stop_all: '全部停止',
      up_all: '全部升锁',
      down_all: '全部降锁',
      check_all: '全部状态查询'
    },
    // 提示
    tip: {
      duplicated_sn: '输入的地锁编号重复',
      success_send_command: '成功下发指令，稍后请刷新查看最新状态'
    },
    labels: {
      charger: '充电桩',
      charger_sn: '桩编号',
      total_count: '地锁总数',
      stop_count: '停用数',
      up_count: '升锁数',
      down_count: '降锁数',
      offline_count: '离网',
      ow_battery_count: '低电量',
      other_exception: '其他异常',
      status_not_match: '锁与枪状态不符'
    },
    titles: {
      bulk_add_parking_locks: '批量添加地锁',
      base_info: '地锁信息',
      ev_charging_gun_info: '电桩信息',
      nvr_channel_info: '摄像头信息'
    }
  }
}
